import { AxiosRequestConfig } from 'axios';
import { apiClient } from './client';
import { withAuthorizationHeader } from './auth';
import { ListResponse } from '../domain/list';

export type Notification = {
  id: string;
  message: string;
  highlight: string;
  icon: string;
  time: string;
  createdAt: string;
  isRead: boolean;
  category: 'ORDER' | 'CHAT' | 'STOCK' | 'REFUND' | 'DELIVERY';
  title: string;
};

export const getNotifications = async (
  token: string,
  opts: AxiosRequestConfig = {},
): Promise<ListResponse<Notification>> => {
  const response = await apiClient.get<ListResponse<Notification>>(
    `/v1/notifications`,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};

export const markAllNotificationsAsRead = async (
  token: string,
): Promise<{ success: boolean }> => {
  const response = await apiClient.patch<{ success: boolean }>(
    `/v1/notifications/read-all`,
    {},
    withAuthorizationHeader(token),
  );
  return response.data;
};
